module.exports = __webpack_public_path__ + "static/media/dwellPass-logo-beta-red-800w.29f74111.png";